// Frozen copy of main's code for the document_generation_v4_enabled / agency_brand_design_enabled flag-off path; delete with the flag.
import React from 'react';

import { getStaticsBaseUrl } from '@oysterjs/core/config';

/**
 * PDF iframe preview URL and loading state for the HTML document editor toolbar.
 */
export function useEditorPreview(params: {
  showPreview?: boolean;
  workspaceId?: string;
  artifactId?: string;
  artifactVersion?: number;
  templateId?: string;
}) {
  const { showPreview, workspaceId, artifactId, artifactVersion, templateId } = params;

  const [isIframeLoading, setIsIframeLoading] = React.useState(false);
  const [previewKey, setPreviewKey] = React.useState(0);

  React.useEffect(() => {
    if (showPreview) {
      setIsIframeLoading(true);
      setPreviewKey((prev) => prev + 1);
    }
  }, [showPreview, templateId, artifactVersion]);

  const previewUrl = React.useMemo(() => {
    const baseUrl = getStaticsBaseUrl();
    const params = new URLSearchParams();
    params.set('preview', previewKey.toString());

    if (workspaceId && artifactId) {
      if (templateId) {
        params.set('style_id', templateId);
      }
      if (artifactVersion !== undefined) {
        params.set('version', String(artifactVersion));
      }
      const queryString = params.toString() ? `?${params.toString()}` : '';
      return `${baseUrl}/agency/html/${workspaceId}/${artifactId}/v2${queryString}`;
    }

    const queryString = params.toString() ? `?${params.toString()}` : '';
    if (templateId) {
      return `${baseUrl}/agency/preview-html/${templateId}${queryString}`;
    }

    return null;
  }, [artifactId, artifactVersion, previewKey, templateId, workspaceId]);

  const handleIframeLoad = React.useCallback(() => {
    setIsIframeLoading(false);
  }, []);

  return {
    isIframeLoading,
    previewKey,
    previewUrl,
    handleIframeLoad
  };
}
